import btoa from 'btoa-lite';

const toGlobalId = (typename: string, id?: string | number): string =>
  btoa(`${typename}:${id || ''}`);

export default toGlobalId;
